module.exports = __webpack_public_path__ + "img/Thumb_FishingBob.0d1a7810.jpg";